import React from 'react';
import {MarkColor} from '../../../diagnosticReporting/Styles';

//contrast checked for background colors with white texts for AA WCAG standards
export const QuizMarkColor = {
    notComplete: {color:'#707070', className:'circle-before'},
    mark0to29: {color:MarkColor.INCORRECT, className:'triangle-before'},
    mark30to89: {color:'#B3611E', className:'square-before'},
    mark90to100: {color:'#288132', className:'pentagon-before'}
}

const QuizzesLegend = props => {
    const {heading} = props;

    const BlockWithKeyText = props =>{
        const {blockColor, className='', ariaLabel = '', text, rectWidth = '33px', rectHeight = '22px', minElemWidth = '150px'} = props;

        return (<div className='flex flex1 smallGap' role={'list'} aria-label={ariaLabel}>
                    <div className={'flex flexCentre flexAlignCentre smallGap'+(className?' '+className:'')} role={"listitem"} style={{
                        backgroundColor: blockColor,
                        width: rectWidth,
                        height: rectHeight
                    }}></div>
                    <div className={'no-wrap'}>{text}</div>
                </div>);
        }

    return (
        <div className={'flex flexCentre'}>
            <div className='flexColumn padding--m padding-t--s padding-b--l ch-emph-block'>
                <div className='flexWrap flexCentre margin-b--m'>
                    <h2 className={'ch-std-font'} aria-label={'legend for '+heading+' key'}>{heading} key</h2>
                </div>
                <div className='flexWrap flexCentre flexAlignCentre largeGap' style={{lineHeight: '22px'}}>
                    <BlockWithKeyText className={QuizMarkColor.notComplete.className} ariaLabel={'Grey block representing not complete'} text={'Not completed'} blockColor={QuizMarkColor.notComplete.color}/>
                    <BlockWithKeyText className={QuizMarkColor.mark0to29.className} ariaLabel={'Red block representing less than 30 percent'} text={'< 30%'} blockColor={QuizMarkColor.mark0to29.color}/>
                    <BlockWithKeyText className={QuizMarkColor.mark30to89.className} ariaLabel={'Orange block representing between 30 and 89 percent'} text={'30% - 89%'} blockColor={QuizMarkColor.mark30to89.color}/>
                    <BlockWithKeyText className={QuizMarkColor.mark90to100.className} ariaLabel={'Green block representing between 90 and 100 percent'} text={'90% - 100%'} blockColor={QuizMarkColor.mark90to100.color}/>
                </div>
            </div>
        </div>
    )
}

export default QuizzesLegend;